import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Textarea, Group, Text, Box, Divider, Button, Badge, Mark, TextInput } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { regexNumberOnly, safeValue, getObjectParam2, numberWithComma, sqlDateToIsoDate, stringDivider, getValuePropInObj } from "../../utils/globalFunctions";

import ModalWrapperWithFooterCloseButton from "../../components/general/ModalWrapperWithFooterCloseButton";
import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";
import InputComponent from "../../components/general/InputComponent";
import StepSelesaiTambahanStock from "./StepSelesaiTambahanStock";
import StepSelesaiTambahanJasa from "./StepSelesaiTambahanJasa";
import StepSelesaiTotalPembayaran from "./StepSelesaiTotalPembayaran";

import StepSelesaiReminderMaintenanceModal from "./StepSelesaiReminderMaintenanceModal";

const calculateQtyCost = (array, propertyQty, propertyHarga) => {
  const total = array.reduce((accumulator, object) => {
    return accumulator + (Number(object[propertyQty] * Number(object[propertyHarga])));
  }, 0);

  return total;
}

const StepSelesai = ({
  stateData,
  stateShowNextComponent = false,
  fnClickPhoto,
  fnCloseDrawer,
  fnSuccessTakesThisProject,
  fnRefreshSudahDiambilIndex
}) => {

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'stepSelesai-1',
    errorPemakaianHarga: 'stepSelesai-2',

    errorRollBackPengerjaan: 'stepSelesai-3',
    sucessRollBackPengerjaan: 'stepSelesai-4',

    errorSerahkanProject: 'stepSelesai-5',
    sucessSerahkanProject: 'stepSelesai-6',
  })

  const [data, setData] = React.useState({
    dataInitLoading: false,
    dataPenggunaanStock: [],
    dataTambahanStock: [],
    dataJasa: [],

    discVoucherId: '',
    discVoucherName: '',
    discVoucherFlag: '',
    discVoucherType: '',
    discVoucherValue: '',
    discVoucherDeductedFrom: '',
    discVoucherCode: '',
    discVoucherRes: '',
    discVoucherNameRes: '',

    totalBiayaStock: '0',
    totalBiayaJasa: '0',
    subTotal: '0',
    dp: '0',
    diskon: '0',
    total: '0',
    statusLunas: '0',
    pelunasanMetode: '',
    pelunasanTanggal: null,
    projectRating: null,

    pengambilanTanggal: null,
    catatanSelesai: '',

    projectId: '',
    clientId: '',
    clientName: '',

    hargaStock: {
      modalShow: false,
      modalHarga: '',
      modalHargaError: '',
      modalHargaPlaceHolder: '',
      stockName: '',
      pengerjaanStockId: '',
      submitLoading: false
    },

    rollBackPengerjaan: {
      modal: false,
      keterangan: '',
      keteranganError: '',
      submitLoading: false,
    },

    selesai: {
      modal: false,
    },

    submitConfirmationModal: false,
    submitLoading: false,

    taggedInfo: {
      modal: false,
      customerName: '',
      projectId: ''
    },

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    const penggunaanStock = calculateQtyCost(data.dataPenggunaanStock, 'project_pengerjaan_stock_jumlah_penggunaan', 'project_pengerjaan_stock_harga_jual_actual');

    const tambahanStock = calculateQtyCost(data.dataTambahanStock, 'project_tambahan_stock_jumlah_penggunaan', 'project_tambahan_stock_harga_jual_actual');

    const tambahanJasa = calculateQtyCost(data.dataJasa, 'project_tambahan_jasa_jumlah', 'project_tambahan_jasa_harga_aktual');

    let subTotalRes = 0;
    let perhitunganDiskonVoucher = 0;
    let discVoucherNameUtils = '';

    subTotalRes = penggunaanStock + tambahanStock + tambahanJasa;

    const vocer = (data.discVoucherFlag === utils.discountFlag.voucher.value) && (data.discVoucherCode);
    const diskonn = (data.discVoucherFlag === utils.discountFlag.discount.value) && (!data.discVoucherCode);

    if (data.discVoucherId && data.discVoucherValue && data.discVoucherDeductedFrom && data.discVoucherType && (vocer || diskonn)) {
      if ((data.discVoucherDeductedFrom === utils.discountDeductedFrom.jasa.value) && (data.discVoucherType === utils.discountType.percent.value)) {
        perhitunganDiskonVoucher = (tambahanJasa * Number(data.discVoucherValue) / 100);
      } else if ((data.discVoucherDeductedFrom === utils.discountDeductedFrom.total.value) && (data.discVoucherType === utils.discountType.rupiah.value)) {
        perhitunganDiskonVoucher = Number(data.discVoucherValue);
      }

      discVoucherNameUtils = data.discVoucherType === utils.discountType.rupiah.value ? `Rp ${numberWithComma(Number(data.discVoucherValue))}` : `${Number(data.discVoucherValue)}% - ${getValuePropInObj(utils.discountDeductedFrom, 'value', data.discVoucherDeductedFrom, 'label', ' - ')}`;
    }

    setData(d => ({
      ...d,
      discVoucherNameRes: (data.discVoucherName ? data.discVoucherName : '') + ' ' + (discVoucherNameUtils ? discVoucherNameUtils : ' - '),
      discVoucherRes: perhitunganDiskonVoucher,
      subTotal: subTotalRes,
      total: subTotalRes - perhitunganDiskonVoucher - Number(data.dp) - Number(data.diskon),
      totalBiayaStock: penggunaanStock + tambahanStock,
      totalBiayaJasa: tambahanJasa
    }))
  }, [
    data.dataPenggunaanStock,
    data.dataTambahanStock,
    data.dataJasa,
    data.dp,
    data.diskon,

    data.discVoucherDeductedFrom,
    data.discVoucherFlag,
    data.discVoucherType,
    data.discVoucherValue,
    data.discVoucherCode,
    data.discVoucherId,
    data.discVoucherName
  ])

  React.useEffect(() => {
    setData(d => ({ ...d, dataInitLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', stateData.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);

    axios({
      method: 'post',
      url: BE_API_TWO + '/modul_pembayaran',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataInitLoading: false }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          projectId: response.data.project_id,
          clientId: response.data.client_id,
          clientName: response.data.client_name,

          dp: safeValue(response.data.biaya_dp, '0'),
          diskon: safeValue(response.data.diskon, '0'),
          statusLunas: safeValue(response.data.is_lunas, '0'),
          pelunasanMetode: safeValue(response.data.biaya_pelunasan_metode, ''),
          pelunasanTanggal: sqlDateToIsoDate(response.data.tanggal_pelunasan, null),
          projectRating: response.data.project_rating,

          pengambilanTanggal: sqlDateToIsoDate(response.data.tanggal_ambil, null),
          catatanSelesai: safeValue(response.data.catatan_selesai, ''),

          dataPenggunaanStock: response.data.penggunaan_stock,
          dataTambahanStock: response.data.tambahan_stock,
          dataJasa: response.data.tambahan_jasa,

          discVoucherId: response.data.disc_voucher_id,
          discVoucherName: response.data.disc_voucher_name,
          discVoucherFlag: response.data.disc_voucher_flag,
          discVoucherType: response.data.disc_voucher_type,
          discVoucherValue: response.data.disc_voucher_value,
          discVoucherDeductedFrom: response.data.disc_voucher_deducted_from,
          discVoucherCode: response.data.disc_voucher_code
        }));
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        dataInitLoading: false,
      }));

      notifications.show({
        id: notificationId.current.errorGetData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }, [handleSetLoginContext, loginContext.syswebapp, stateData.projectId, stateData.projectProcess, stateData.projectIsCancel, stateData.refreshStepSelesai])

  const submitDataHargaStock = () => {
    setData(d => ({ ...d, hargaStock: { ...d.hargaStock, modalHargaError: '' } }));

    if (validator.isEmpty(data.hargaStock.modalHarga, { ignore_whitespace: true })) {
      setData(d => ({ ...d, hargaStock: { ...d.hargaStock, modalHargaError: 'Isi harga stock terlebih dahulu.' } }));
    } else {
      setData(d => ({ ...d, hargaStock: { ...d.hargaStock, submitLoading: true } }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', data.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      formDT.append('harga', data.hargaStock.modalHarga);
      formDT.append('pengerjaan_stock_id', data.hargaStock.pengerjaanStockId);

      axios({
        method: 'post',
        url: BE_API_TWO + '/pembayaran_pemakaian_stock_harga',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, hargaStock: { ...d.hargaStock, submitLoading: false, modalShow: false } }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            dataPenggunaanStock: response.data.data,
            hargaStock: {
              ...d.hargaStock,
              modalHarga: ''
            }
          }));
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorPemakaianHarga,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, hargaStock: { ...d.hargaStock, submitLoading: false, modalShow: false } }));

        notifications.show({
          id: notificationId.current.errorPemakaianHarga,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  const submitRollBackPengerjaan = () => {
    setData(d => ({ ...d, rollBackPengerjaan: { ...d.rollBackPengerjaan, keteranganError: '' } }));

    if (validator.isEmpty(data.rollBackPengerjaan.keterangan, { ignore_whitespace: true })) {
      setData(d => ({ ...d, rollBackPengerjaan: { ...d.rollBackPengerjaan, keteranganError: 'Isi keterangan terlebih dahulu.' } }));
    } else {
      setData(d => ({ ...d, rollBackPengerjaan: { ...d.rollBackPengerjaan, submitLoading: true } }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.projectId);
      formDT.append('project_process_pengerjaan', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      formDT.append('project_process_pengerjaan_value', utils.projectProcess.pengerjaan.value);
      formDT.append('project_pengerjaan_progress', JSON.stringify(utils.pengerjaanProgress.pengerjaan));
      formDT.append('project_selesai_reject', JSON.stringify(utils.pengerjaanProgress.selesai_rejected));

      formDT.append('keterangan', data.rollBackPengerjaan.keterangan);

      axios({
        method: 'post',
        url: BE_API_TWO + '/tolak_selesai',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, rollBackPengerjaan: { ...d.rollBackPengerjaan, submitLoading: false, modal: false } }));

        if (response.data.flag_status === 'isset') {
          fnCloseDrawer();
          fnSuccessTakesThisProject();

          notifications.show({
            id: notificationId.current.sucessRollBackPengerjaan,
            title: utils.notification.success.caption,
            message: 'Berhasil Submit Data',
            color: utils.notification.success.color,
            icon: utils.notification.success.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorRollBackPengerjaan,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'not-complete-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: response.data.message,
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, rollBackPengerjaan: { ...d.rollBackPengerjaan, submitLoading: false, modal: false } }));

        notifications.show({
          id: notificationId.current.errorRollBackPengerjaan,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  return (
    <React.Fragment>
      {data.dataInitLoading &&
        <PaperWrapper>
          <Text size='sm' color="dimmed">Loading Data Pembayaran..</Text>
        </PaperWrapper>
      }

      {!data.dataInitLoading &&
        <React.Fragment>
          <Text
            mt='lg'
            mb='sm'
            tt='uppercase'
          >
            Pembayaran
          </Text>

          <PaperWrapper stateMB="2rem">
            <Text>Pemakaian Stock Item</Text>

            <Divider my='xs' />

            {Array.isArray(data.dataPenggunaanStock) && (data.dataPenggunaanStock.length > 0) && Object.keys(data.dataPenggunaanStock).map((keyPS, indexPS) => {
              return (
                <Group
                  key={keyPS}

                  noWrap
                  mt='lg'
                  sx={(tema) => ({
                    alignItems: 'flex-start'
                  })}
                >
                  <Text size='sm'>{Number(indexPS) + 1}</Text>

                  <Box sx={{ width: '100%' }}>
                    <Group spacing={6}>
                      <Text size='sm'>
                        {`${data.dataPenggunaanStock[keyPS].stock_category_name} ${data.dataPenggunaanStock[keyPS].stock_category_sub_name} ${safeValue(data.dataPenggunaanStock[keyPS].stock_serial_number, '')}`}
                      </Text>

                      <Badge
                        size='md'
                        color={getObjectParam2(utils.stockItemStatus, data.dataPenggunaanStock[keyPS].stock_status, 'color', 'gray')}

                        onClick={
                          // data.dataPenggunaanStock[keyPS].stock_status === utils.stockItemStatus.tagged.value ?
                          () => {
                            setData(d => ({
                              ...d,
                              taggedInfo: {
                                ...d.taggedInfo,
                                customerName: data.dataPenggunaanStock[keyPS].customer_name,
                                projectId: data.dataPenggunaanStock[keyPS].tagged_project_id,
                                modal: true
                              }
                            }));
                          }
                          // :() => { }
                        }

                        sx={(tema) => ({
                          cursor: 'pointer',
                          // cursor: data.dataPenggunaanStock[keyPS].stock_status === utils.stockItemStatus.tagged.value ? 'pointer' : 'default'
                        })}

                        styles={(tema) => ({
                          inner: {
                            fontWeight: 'normal',
                            textTransform: 'none',
                          }
                        })}
                      >
                        {getObjectParam2(utils.stockItemStatus, data.dataPenggunaanStock[keyPS].stock_status, 'caption', ' - ')}
                      </Badge>
                    </Group>

                    <Box>
                      {
                        // data.dataPenggunaanStock[keyPS].stock_status === utils.stockItemStatus.tagged.value && 
                        data.dataPenggunaanStock[keyPS].customer_name &&
                        <Text size='xs' color={getObjectParam2(utils.stockItemStatus, data.dataPenggunaanStock[keyPS].stock_status, 'color', 'gray')}>
                          Tagged {safeValue(data.dataPenggunaanStock[keyPS].customer_name, ' - ')}
                        </Text>
                      }

                      {
                        // data.dataPenggunaanStock[keyPS].stock_status === utils.stockItemStatus.tagged.value && 
                        data.dataPenggunaanStock[keyPS].tagged_project_id &&
                        <Text size='xs' color={getObjectParam2(utils.stockItemStatus, data.dataPenggunaanStock[keyPS].stock_status, 'color', 'gray')}>
                          Tagged {stringDivider(data.dataPenggunaanStock[keyPS].tagged_project_id, [4, 6, 8], '.', ' - ')}
                        </Text>
                      }
                    </Box>

                    <Group noWrap spacing='xs' mt='xs'>
                      <TextInput
                        id={'harga-penggunaan-stock' + indexPS}
                        size="xs"
                        variant='default'
                        icon={
                          <Text color="dimmed" size='sm'>
                            {safeValue(data.dataPenggunaanStock[keyPS].project_pengerjaan_stock_jumlah_penggunaan, '')} x Rp
                          </Text>
                        }
                        readOnly={true}
                        placeholder='Harga Satuan'
                        value={numberWithComma(safeValue(data.dataPenggunaanStock[keyPS].project_pengerjaan_stock_harga_jual_actual, ''))}

                        onClick={() => {
                          setData(d => ({
                            ...d,
                            hargaStock: {
                              ...d.hargaStock,
                              modalHarga: data.dataPenggunaanStock[keyPS].project_pengerjaan_stock_harga_jual_actual,
                              modalHargaError: '',

                              modalHargaPlaceHolder: data.dataPenggunaanStock[keyPS].stock_harga_jual,

                              stockName: `${data.dataPenggunaanStock[keyPS].stock_category_name} ${data.dataPenggunaanStock[keyPS].stock_category_sub_name} ${safeValue(data.dataPenggunaanStock[keyPS].stock_serial_number, '')}`,

                              pengerjaanStockId: data.dataPenggunaanStock[keyPS].project_pengerjaan_stock_id,
                              modalShow: true
                            }
                          }))
                        }}

                        sx={{
                          width: `100% !important`
                        }}
                        styles={(tema) => ({
                          input: {
                            backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                            paddingLeft: '4.5rem !important'
                          },
                          icon: {
                            width: '4.5rem'
                          }
                        })}
                      />
                    </Group>
                  </Box>
                </Group>
              )
            })
            }

            {Array.isArray(data.dataPenggunaanStock) && (data.dataPenggunaanStock.length <= 0) &&
              <Text size='sm' color="dimmed">Tidak ada stock item yang digunakan.</Text>
            }
          </PaperWrapper>

          <StepSelesaiTambahanStock
            stateData={{
              data: data.dataTambahanStock,
              projectId: data.projectId,
              clientId: data.clientId,
              clientName: data.clientName,
              projectProcess: stateData.projectProcess,
              projectIsCancel: stateData.projectIsCancel,
              userAccess: stateData.userAccess,
            }}

            fnOnChange={(dataArray) => {
              setData(d => ({ ...d, dataTambahanStock: dataArray }))
            }}
          />

          <StepSelesaiTambahanJasa
            stateData={{
              data: data.dataJasa,
              projectId: data.projectId,
              clientId: data.clientId,
              clientName: data.clientName,
              projectProcess: stateData.projectProcess,
              projectIsCancel: stateData.projectIsCancel,
              userAccess: stateData.userAccess,
            }}

            fnOnChange={(dataArray) => {
              setData(d => ({ ...d, dataJasa: dataArray }))
            }}
          />

          <StepSelesaiTotalPembayaran
            stateData={{
              projectId: data.projectId,
              projectProcess: stateData.projectProcess,
              projectIsCancel: stateData.projectIsCancel,
              userAccess: stateData.userAccess,

              discVoucherNameRes: data.discVoucherNameRes,
              discVoucherRes: data.discVoucherRes,
              totalBiayaStock: data.totalBiayaStock,
              totalBiayaJasa: data.totalBiayaJasa,
              subTotal: data.subTotal,
              dp: data.dp,
              diskon: data.diskon,
              total: data.total,
              statusLunas: data.statusLunas,
              pelunasanMetode: data.pelunasanMetode,
              pelunasanTanggal: data.pelunasanTanggal,
              pengambilanTanggal: data.pengambilanTanggal,
              catatanSelesai: data.catatanSelesai,
              projectRating: data.projectRating,
            }}

            fnOnChangeDiskon={(val) => setData(d => ({ ...d, diskon: val }))}

            fnOnChangeStatusLunas={(dataArray) => {
              setData(d => ({
                ...d,
                statusLunas: (Array.isArray(dataArray) && (dataArray.length > 0)) ? safeValue(dataArray[0]['is_lunas'], '0') : '0',
                pelunasanMetode: (Array.isArray(dataArray) && (dataArray.length > 0)) ? safeValue(dataArray[0]['biaya_pelunasan_metode'], '') : '',
                pelunasanTanggal: (Array.isArray(dataArray) && (dataArray.length > 0)) ? sqlDateToIsoDate(dataArray[0]['tanggal_pelunasan'], null) : null,
              }))
            }}

            fnOnChangePelunasanMetode={(val) => setData(d => ({ ...d, pelunasanMetode: val }))}

            fnOnChangePelunasanTanggal={(val) => setData(d => ({ ...d, pelunasanTanggal: val }))}

            fnOnChangePengambilanTanggal={(val) => setData(d => ({ ...d, pengambilanTanggal: val }))}

            fnOnChangeCatatanSelesai={(val) => setData(d => ({ ...d, catatanSelesai: safeValue(val, '') }))}

            fnOnChangeProjectRating={(val) => {
              setData(d => ({ ...d, projectRating: val }));
              fnRefreshSudahDiambilIndex();
            }}
          />

          {stateShowNextComponent &&
            <PaperWrapper stateMB="2rem">
              <Text>Pastikan Rincian Pembayaran Sudah Sesuai</Text>

              <Divider my='xs' />

              <Text size='sm' my='xs' color="dimmed">
                Jika barang masih belum sesuai dan masih harus diperbaiki, pilih "Ke Pengerjaan" untuk kembali ke step pengerjaan.
              </Text>

              <Text size='sm' mt='xs' mb='lg' color="dimmed">
                Jika barang sudah benar dan sesuai, pilih "Selesai".
              </Text>

              <Group noWrap>
                <Button
                  variant="light"
                  color="red"
                  fullWidth
                  onClick={() => {
                    setData(d => ({
                      ...d, rollBackPengerjaan: { ...d.rollBackPengerjaan, modal: true }
                    }));
                  }}
                >
                  Ke Pengerjaan
                </Button>

                <Button
                  fullWidth
                  onClick={() => {
                    setData(d => ({
                      ...d, selesai: { ...d.selesai, modal: true }
                    }));
                  }}
                >
                  Selesai
                </Button>
              </Group>
            </PaperWrapper>
          }
        </React.Fragment>
      }

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.hargaStock.modalShow}
        fnHide={() => setData(d => ({
          ...d,
          hargaStock: {
            ...d.hargaStock,
            modalShow: false
          }
        }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Harga Stock Item').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.hargaStock.submitLoading}
        fnButtonAction={submitDataHargaStock}
      >
        <InputComponent
          stateId='hargaPenggunaanStockModal-1'
          stateWithAsterisk={false}
          stateLabel={<Text color="dimmed">{data.hargaStock.stockName}</Text>}
          stateDescription=''
          statePlaceHolder={data.hargaStock.modalHargaPlaceHolder ? numberWithComma(data.hargaStock.modalHargaPlaceHolder) : ''}
          stateReadOnly={false}
          stateValue={numberWithComma(data.hargaStock.modalHarga)}
          stateError={data.hargaStock.modalHargaError}
          stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

          fnOnChange={(e) => setData(d => ({
            ...d,
            hargaStock: {
              ...d.hargaStock,
              modalHarga: regexNumberOnly(e.target.value)
            }
          }))}
        />
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.rollBackPengerjaan.modal}
        fnHide={() => setData(d => ({
          ...d,
          rollBackPengerjaan: {
            ...d.rollBackPengerjaan,
            modal: false
          }
        }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Keterangan').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="red"
        stateButtonActionLoading={data.rollBackPengerjaan.submitLoading}
        fnButtonAction={submitRollBackPengerjaan}
      >
        <Textarea
          value={data.rollBackPengerjaan.keterangan}
          minRows={3}
          maxRows={4}
          onChange={(e) => {
            setData(d => ({
              ...d,
              rollBackPengerjaan: {
                ...d.rollBackPengerjaan,
                keterangan: e.target.value
              }
            }))
          }}

          label='Catatan'
          placeholder='Keterangan / Catatan'
          error={data.rollBackPengerjaan.keteranganError}
          description='Project akan dikembalikan ke proses pengerjaan.'
          withAsterisk={false}
        />
      </ModalTakeAction>

      <StepSelesaiReminderMaintenanceModal
        stateShow={data.selesai.modal}
        fnShow={() => setData(d => ({ ...d, selesai: { ...d.selesai, modal: false } }))}

        stateData={{
          projectId: stateData.projectId,
          projectProcess: stateData.projectProcess,
          projectIsCancel: stateData.projectIsCancel
        }}

        fnSuccess={() => {
          fnCloseDrawer();
          fnSuccessTakesThisProject();

          notifications.show({
            id: notificationId.current.sucessSerahkanProject,
            title: utils.notification.success.caption,
            message: 'Berhasil Submit Data',
            color: utils.notification.success.color,
            icon: utils.notification.success.icon,
            withBorder: true,
            autoClose: true,
          })
        }}
      />

      <ModalWrapperWithFooterCloseButton
        stateShow={data.taggedInfo.modal}
        fnHide={() => setData(d => ({ ...d, taggedInfo: { ...d.taggedInfo, modal: false } }))}
        stateHideOnClickOutSide={true}
        stateTitle={String('Information').toUpperCase()}
        // stateSize='xl'
        stateOverlayZIndex={201}
        stateWithCloseButton={true}
        stateScrollArea={true}

        stateButtonCloseCaption="Close"
        stateButtonCloseSize="xs"
        stateButtonClosePx="lg"
      >
        {data.taggedInfo.customerName ?
          <Text size='sm' color='dimmed'>
            Item ini sudah ditandai untuk customer <Mark>&nbsp;{safeValue(data.taggedInfo.customerName, ' - ')}&nbsp;</Mark>
          </Text>
          :
          <Text size='sm' color='dimmed'>
            Tidak ada customer tag untuk item ini.
          </Text>
        }

        {data.taggedInfo.projectId ?
          <Text size='sm' color='dimmed'>
            Item ini sudah ditandai untuk project <Mark>&nbsp;{stringDivider(data.taggedInfo.projectId, [4, 6, 8], '.', ' - ')}&nbsp;</Mark>
          </Text>
          :
          <Text size='sm' color='dimmed'>
            Tidak ada project tag untuk item ini.
          </Text>
        }
      </ModalWrapperWithFooterCloseButton>
    </React.Fragment>
  )
}

export default StepSelesai;